import CreatedTripInfo from './CreatedTripInfo';

export default CreatedTripInfo;
